/* C4 -- add to cart from the product page WITHOUT leaving it, and the replace-the-line transaction.
 *
 * WHAT THIS FILE OWNS
 *   1. Any add to cart from the C4 product form posts /cart/add.js, refreshes the cart drawer and
 *      opens it. The page stays put (Cathy, 14 Sep 2026: "any add to cart button adds/opens cart
 *      drawer. the cart from the header should go to the full cart").
 *   2. The replace-the-line transaction (C4-Cart-Identity-Model.md). When the page was reached
 *      from a cart line (?pp_line=<key>) the add REPLACES that line: add first, confirm the new
 *      line is in the cart, only then remove the old one, only then release the draft. Never the
 *      reverse. One replacement per trip. When anything is ambiguous, keep both lines.
 *
 * HOW THE ADD REACHES US -- three doors, one handler
 *   a. Apippa (Custom Price Calculator). Its own jQuery submit handler runs first on the customer's
 *      click: it creates the priced variant on its API, writes #variantIdCustom (name=id) and its
 *      property inputs, then -- with the app's "cart drawer integration" switched ON -- re-submits
 *      the form for the theme to handle. That second submit has no `submitter`, which is how we
 *      tell it from the customer's click. With the integration OFF Apippa instead posts /cart/add
 *      itself and navigates to /cart -- see door d.
 *   b. form.submit() called by a script. The instance method is shadowed below so it lands here
 *      instead of navigating.
 *   c. window.c4CartAdd(formData, opts) -- used by the basic (real-variant) form's own script.
 *   d. Apippa's OWN add (15 Sep 2026). Apippa has no "cart drawer integration" setting to switch
 *      on (Cathy checked), so on every calculator product it does `$.ajax POST /cart/add` with a
 *      FormData, then `window.location.href = "/cart"`. That bypasses everything here: no drawer,
 *      no replace-the-line, no frozen design copy. So the XMLHttpRequest that Apippa builds for
 *      that post is intercepted at send(): if the body is a FormData carrying Apippa's own
 *      `properties[_cpc_custom_cart_item]`, the request is NOT sent and the same FormData goes
 *      through add() instead. Apippa's success handler (which would redirect) never fires; its
 *      spinner is hidden by us and its in-progress flag is reset the one way its code allows
 *      (it listens for a bfcache `pageshow`). If add() fails, the original send() is issued and
 *      Apippa's own flow runs exactly as before -- the fallback is the old behaviour.
 *
 * FALLBACK IS ALWAYS THE NATIVE POST. If the events module cannot load, if fetch fails, if the
 * response is not a line item -- the form is submitted the way it always was and the customer
 * lands on /cart with the line added. The worst case is the old behaviour, never a lost add.
 *
 * WHAT WE DO NOT DO: we never remove a line before the replacement is confirmed; we never touch a
 * line we did not arrive from; we never remove on a merged add (identical line -> Shopify bumps
 * the quantity of the same key) -- there the quantity is set back to the replacement's own.
 */
(function () {
  if (window.__c4CartAdd) return;
  window.__c4CartAdd = true;

  var FORM_ID = 'c4-product-form';
  var SECTION = 'cart-drawer-section';
  var nativeSubmit = HTMLFormElement.prototype.submit;
  var busy = false;

  /* The @shopify/events module is what the drawer, the header bubble and the cart items listen
     to. It is loaded lazily, once, and its absence only costs the in-page refresh. */
  var eventsMod = null;
  var eventsLoad = null;
  function events() {
    if (eventsMod) return Promise.resolve(eventsMod);
    if (!eventsLoad) {
      /* Shopify minifies theme assets with a bundler that rewrites a bare import() into a
         require() call, which does not exist in the browser (found 14 Sep 2026: the event was
         never dispatched). Building the import in a Function keeps it out of the bundler's sight. */
      var dyn;
      try { dyn = new Function('u', 'return import(u)'); } catch (e) { dyn = null; }
      eventsLoad = (dyn ? dyn('https://cdn.shopify.com/storefront/standard-events.js') : Promise.reject(new Error('no import')))
        .then(function (m) { eventsMod = m; return m; })
        .catch(function () { eventsLoad = null; return null; });
    }
    return eventsLoad;
  }

  function form() { return document.getElementById(FORM_ID); }
  function param(name) {
    try { return new URLSearchParams(location.search).get(name) || ''; } catch (e) { return ''; }
  }
  function working(title, body) {
    document.dispatchEvent(new CustomEvent('c4:working', { detail: { title: title, body: body } }));
  }
  function done() { document.dispatchEvent(new CustomEvent('c4:done')); }
  function json(r) {
    return r.text().then(function (t) {
      try { return JSON.parse(t); } catch (e) { return null; }
    });
  }
  function cartJson() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(json);
  }

  /* Apippa renders its own inputs OUTSIDE the form and copies them in only for its own post.
     If the form data we were handed lacks the variant id, gather what the page holds: the
     priced variant (#variantIdCustom), its price token, and any calculator property not already
     present. Nothing already in the form is overwritten. */
  function complete(fd) {
    if (!fd.get('id')) {
      var vic = document.getElementById('variantIdCustom');
      if (vic && vic.value && vic.value !== '0') fd.set('id', vic.value);
    }
    var tok = document.getElementById('cpcPriceToken');
    if (tok && tok.name && tok.value && !fd.has(tok.name)) fd.set(tok.name, tok.value);
    var f = form();
    var all = document.querySelectorAll('#calculator input[name^="properties["], #calculator select[name^="properties["], #calculator textarea[name^="properties["]');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (f && f.contains(el)) continue;
      if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) continue;
      if (!fd.has(el.name)) fd.set(el.name, el.value);
    }
    if (!fd.get('quantity')) fd.set('quantity', '1');
    fd.set('sections', SECTION);
    fd.set('sections_url', location.pathname);
    return fd;
  }

  /* Open Horizon's drawer. theme-drawer owns the dialog; open() is its public method. */
  function openDrawer() {
    var c = document.querySelector('cart-drawer-component');
    var d = c && c.closest('theme-drawer');
    try {
      if (d && typeof d.open === 'function') { d.open(); return true; }
      var dlg = c && c.closest('dialog');
      if (dlg && !dlg.open && dlg.showModal) { dlg.showModal(); return true; }
    } catch (e) {}
    return false;
  }

  /* Tell the theme the cart changed, the way Horizon's own product form does, so the drawer's
     items morph in from the sections we asked for and the header bubble updates. */
  function announce(action, ajaxCart, sections, itemCount, lines) {
    return events().then(function (m) {
      if (!m || !m.CartLinesUpdateEvent) return;
      var deferred = m.CartLinesUpdateEvent.createPromise();
      var target = form() || document;
      target.dispatchEvent(new m.CartLinesUpdateEvent({
        action: action, context: 'product', lines: lines || [], promise: deferred.promise
      }));
      deferred.resolve({
        cart: m.CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
        detail: { items: ajaxCart.items, sections: sections, itemCount: itemCount, didError: false, source: 'c4-cart-add' }
      });
    }).catch(function () {});
  }

  function dropResumeParams() {
    try {
      var u = new URL(location.href);
      if (!u.searchParams.has('pp_line') && !u.searchParams.has('pp_project')) return;
      u.searchParams.delete('pp_line');
      u.searchParams.delete('pp_project');
      history.replaceState({}, '', u.pathname + (u.search || '') + u.hash);
    } catch (e) {}
  }

  /* ---- the transaction ------------------------------------------------------------------ */
  function add(fd, opts) {
    opts = opts || {};
    if (busy) return Promise.resolve({ ok: false, reason: 'busy' });
    busy = true;
    complete(fd);
    if (!fd.get('id')) { busy = false; return Promise.resolve({ ok: false, reason: 'no-id' }); }

    var editKey = param('pp_line');
    var oldLine = null;
    working('Adding to your cart', editKey ? 'Updating the line you came from.' : 'One moment.');

    var pre = editKey
      ? cartJson().then(function (cart) {
          (cart && cart.items || []).forEach(function (it) { if (!oldLine && it.key === editKey) oldLine = it; });
        }).catch(function () {})
      : Promise.resolve();

    return pre.then(function () {
      return freezeDesign(fd);
    }).then(function () {
      return fetch('/cart/add.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'application/json' } });
    }).then(function (r) {
      return json(r).then(function (data) {
        if (!r.ok || !data || data.status) {
          var msg = (data && (data.description || data.message)) || ('Add to cart failed (' + r.status + ')');
          throw new Error(msg);
        }
        var item = data.items ? data.items[0] : data;
        if (!item || !item.key) throw new Error('No line returned');
        return { item: item, sections: data.sections || null };
      });
    }).then(function (res) {
      /* CONFIRM before anything is removed: the new key must be in the cart we read back. */
      return cartJson().then(function (cart) {
        var present = (cart && cart.items || []).some(function (it) { return it.key === res.item.key; });
        if (!present) throw new Error('Line not confirmed in cart');
        res.cart = cart;
        return res;
      });
    }).then(function (res) {
      if (!oldLine) return res;
      var body;
      if (res.item.key !== oldLine.key) {
        body = { id: oldLine.key, quantity: 0 };
      } else {
        /* Identical line: Shopify merged the add into the SAME key. The line now holds old + new;
           keep only the replacement's own quantity. */
        var keep = Math.max(1, (res.item.quantity || 1) - (oldLine.quantity || 0));
        if (keep === res.item.quantity) return res;
        body = { id: oldLine.key, quantity: keep };
      }
      body.sections = SECTION;
      body.sections_url = location.pathname;
      return fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(json).then(function (after) {
        if (after && after.items) { res.cart = after; if (after.sections) res.sections = after.sections; }
        res.replaced = oldLine.key;
        tidyReplacedClone(oldLine, res.item);
        return res;
      }).catch(function () { return res; /* keep both -- recoverable */ });
    }).then(function (res) {
      /* One replacement per trip: the line we came from is gone (or kept, on failure); either way
         the next add on this page is a plain add. Dropping the params also lets c4-pitchprint.js
         release the project that is now on a cart line. */
      dropResumeParams();
      document.dispatchEvent(new CustomEvent('c4:cart-added', { detail: { item: res.item, replaced: res.replaced || null } }));
      var count = res.cart ? res.cart.item_count : (res.item.quantity || 1);
      return announce('add', res.cart || { items: [res.item], item_count: count }, res.sections, count,
        [{ merchandiseId: String(res.item.variant_id || fd.get('id')), quantity: res.item.quantity || 1 }]).then(function () {
        done();
        busy = false;
        if (!openDrawer() && !opts.noNavigate) location.href = '/cart';
        return { ok: true, item: res.item, replaced: res.replaced || null };
      });
    }).catch(function (err) {
      busy = false;
      done();
      return { ok: false, reason: (err && err.message) || 'failed' };
    });
  }

  /* ---- frozen copies (see c4-pitchprint.js, section 2c) ------------------------------------
     The line gets a CLONE of the design, never the working project, so a paid order can no
     longer be rewritten by the customer reopening their design. Fail safe: if PitchPrint's clone
     call is unavailable or fails, the add proceeds with the working id exactly as before. */
  var PP_KEY = 'properties[_pitchprint]';
  var PREVIEW_KEY = 'properties[_c4_design_preview]';
  function freezeDesign(fd) {
    var pid = fd.get(PP_KEY);
    var pp = window.c4PP;
    if (!pid || !pp || !pp.clone) return Promise.resolve();
    return pp.clone(pid).then(function (newId) {
      if (!newId) return;
      pp.copyRecord(pid, newId);
      pp.noteClone(newId, pid);
      fd.set(PP_KEY, newId);
      var orig = (fd.get(PREVIEW_KEY) || '').split('?')[0];
      return pp.previewFor(newId, orig).then(function (prev) {
        if (prev) fd.set(PREVIEW_KEY, prev);
      });
    }).catch(function () { /* keep the working id -- the add must not be blocked */ });
  }
  /* After a replace, the line we came from is gone; if it carried a clone WE minted, delete that
     project so the backend keeps one copy per line rather than one per edit. Only ids in our own
     clone map are ever deleted -- never a customer's working design, never an unknown id. */
  function tidyReplacedClone(oldLine, newItem) {
    try {
      var pp = window.c4PP;
      var oldId = oldLine && oldLine.properties && oldLine.properties._pitchprint;
      var newId = newItem && newItem.properties && newItem.properties._pitchprint;
      if (!pp || !pp.remove || !oldId || oldId === newId || !pp.isClone(oldId)) return;
      pp.remove(oldId);
    } catch (e) {}
  }

  function nativeFallback(f) {
    try { nativeSubmit.call(f); } catch (e) { location.href = '/cart'; }
  }

  /* The size guard in c4-legacy.js (15 Sep 2026): while a product with Width/Height boxes has
     either at 0, the button carries data-c4-size-wait and NOTHING may add -- not a scripted
     submit, not a hand-back, not the native fallback. Checked here because this listener is
     registered before the guard's own and would otherwise treat a stray submit as Apippa's
     hand-back and fall through to a native POST with no variant id. */
  function sizeWait() {
    return !!document.querySelector('[data-c4-cta][data-c4-size-wait]');
  }

  function handleSubmitLike(f, fd, viaNative) {
    if (sizeWait()) return;
    add(fd).then(function (r) {
      if (r.ok || r.reason === 'busy') return;
      if (r.reason === 'no-id') { nativeFallback(f); return; }
      /* The add itself failed: say so on the button rather than bouncing to an error page. */
      var btn = f.querySelector('[data-c4-proxy-add], [data-c4-basic-add], [type="submit"]');
      if (btn) {
        var n = document.createElement('p');
        n.style.cssText = 'margin:8px 0 0;font:600 13px/1.4 system-ui,sans-serif;color:#b3261e';
        n.textContent = r.reason === 'failed' ? 'Could not add to cart. Please try again.' : r.reason;
        btn.insertAdjacentElement('afterend', n);
        setTimeout(function () { n.remove(); }, 7000);
      } else if (viaNative) {
        nativeFallback(f);
      }
    });
  }

  /* ---- doors ---------------------------------------------------------------------------- */
  window.c4CartAdd = function (fd, opts) { return add(fd, opts); };

  /* door d: Apippa's own XHR to /cart/add (see the header). */
  (function hijackApippaAdd() {
    var XHR = window.XMLHttpRequest;
    if (!XHR || XHR.prototype.__c4Hooked) return;
    XHR.prototype.__c4Hooked = true;
    var open = XHR.prototype.open;
    var send = XHR.prototype.send;
    XHR.prototype.open = function (method, url) {
      try { this.__c4 = { m: String(method || '').toUpperCase(), u: String(url || '') }; } catch (e) {}
      return open.apply(this, arguments);
    };
    XHR.prototype.send = function (body) {
      var x = this;
      var meta = x.__c4;
      var isApippaAdd = false;
      try {
        isApippaAdd = !!(meta && meta.m === 'POST' && /^(?:https?:\/\/[^/]+)?\/cart\/add(?:\?|$)/.test(meta.u) &&
          body && typeof FormData !== 'undefined' && body instanceof FormData &&
          body.has('properties[_cpc_custom_cart_item]') && form());
      } catch (e) { isApippaAdd = false; }
      if (!isApippaAdd) return send.apply(x, arguments);

      var fd = new FormData();
      body.forEach(function (v, k) { fd.append(k, v); });
      add(fd).then(function (r) {
        if (r.ok) { apippaSettle(); return; }
        if (r.reason === 'busy') { apippaSettle(); return; }
        /* Our add could not complete: let Apippa's own request go, exactly as before. */
        try { send.call(x, body); } catch (e) { location.href = '/cart'; }
      });
    };
  })();

  /* Apippa is left waiting on a request that will never answer: hide its spinner and reset its
     in-progress flag. That flag is module-private; the only reset its code exposes is the bfcache
     restore listener, so a synthetic persisted `pageshow` is the lever. Without it a second add on
     the same page would be silently ignored until a reload. */
  function apippaSettle() {
    try {
      document.querySelectorAll('.loading-anim-cpc').forEach(function (el) { el.style.display = 'none'; });
    } catch (e) {}
    try {
      var ev;
      try { ev = new PageTransitionEvent('pageshow', { persisted: true }); }
      catch (e) { ev = new Event('pageshow'); Object.defineProperty(ev, 'persisted', { value: true }); }
      window.dispatchEvent(ev);
    } catch (e) {}
  }

  function wire() {
    var f = form();
    if (!f || f.hasAttribute('data-c4-ajax')) return;
    f.setAttribute('data-c4-ajax', '');
    /* The basic form has its own script that calls window.c4CartAdd; leave its submit alone. */
    var basic = f.hasAttribute('data-c4-basic');

    /* Door b: scripted form.submit() on THIS form. */
    f.submit = function () {
      if (basic) { nativeSubmit.call(f); return; }
      handleSubmitLike(f, new FormData(f), true);
    };

    /* Door a: Apippa's hand-back. The customer's click must reach Apippa untouched (it prices the
       job on its API first). Its hand-back is recognised two ways: a submit event with no
       submitter, or ANY submit that follows a completed pricing call (the /api/v1/variant XHR)
       within a short window of the customer's click. A re-click after a validation failure has
       no pricing call behind it, so it passes through to Apippa again as it should. */
    var clickedAt = 0;
    document.addEventListener('submit', function (e) {
      if (e.target !== f || basic) return;
      if (sizeWait()) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      if (e.defaultPrevented) return;
      var now = Date.now();
      var handBack = !e.submitter || (clickedAt && now - clickedAt < 20000 && pricedAt > clickedAt);
      if (!handBack) { clickedAt = now; return; }
      clickedAt = 0;
      e.preventDefault();
      e.stopImmediatePropagation();
      handleSubmitLike(f, new FormData(f), true);
    }, true);
  }

  /* Observe Apippa's pricing call so the hand-back above can be told from a fresh click. Read
     only: the request is neither altered nor delayed. */
  var pricedAt = 0;
  try {
    var xo = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      this.__c4v = /custompricecalculator\.com\/api\/v1\/variant/.test(String(u));
      return xo.apply(this, arguments);
    };
    var xs = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      if (this.__c4v) this.addEventListener('loadend', function () { pricedAt = Date.now(); });
      return xs.apply(this, arguments);
    };
  } catch (e) {}

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
  else wire();
})();
